/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getDepartment,
  createDepartment,
  editDepartment,
  resetDepartment,
  resetDepartments,
  resetError,
} from "../../store/actions";

const NewDepartment = ({ t }) => {
  let { idCompany, idDepartment } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataDepartmentGetSet,
    dataDepartmentEditCreate,
    loadingDepartmentEditCreate,
    successDepartment,
    errorDepartment,
  } = useSelector((state) => state.Department);

  const [departmentValues, setDepartmentValues] = useState({
    name: "",
    email: "",
  });

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  //TODO: Definir se vai ser default ou criar campos
  const activeDefault = true;
  const mainDefault = false;

  const handleCreateEditDepartment = () => {
    if (idDepartment) {
      if (idCompany) {
        dispatch(editDepartment(idDepartment, newFields, idCompany));
      }
    } else {
      if (idCompany) {
        dispatch(
          createDepartment(
            {
              ...newFields,
              main: mainDefault,
              active: activeDefault,
            },
            idCompany
          )
        );
      }
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successDepartment &&
      dispatch(resetDepartment()) &&
      dispatch(resetDepartments()) &&
      history.push("/departments"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetDepartment());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idDepartment && idCompany) {
      dispatch(getDepartment(idDepartment, idCompany, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idDepartment]);

  useEffect(() => {
    if (idDepartment && dataDepartmentGetSet && dataDepartmentGetSet.data) {
      setDepartmentValues((previous) => ({
        ...previous,
        name: dataDepartmentGetSet.data.name,
        email: dataDepartmentGetSet.data.email,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDepartmentGetSet]);

  useEffect(() => {
    if (dataDepartmentEditCreate && dataDepartmentEditCreate.message) {
      showToast("success", t(dataDepartmentEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successDepartment]);

  useEffect(() => {
    if (errorDepartment && typeof errorDepartment === "object") {
      errorDepartment.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorDepartment) {
        showToast("error", t(errorDepartment));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorDepartment]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/departments"
            path={
              idDepartment
                ? "/company/" + idCompany + "/department/" + idDepartment
                : "/company/" + idCompany + "/department"
            }
            title={t("Departments")}
            breadcrumbItem={
              !idDepartment ? t("Create department") : t("Edit Department")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditDepartment}>
                    <Row>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Department name")}
                            onChange={(e) => {
                              if (e.target.value === departmentValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={departmentValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value: "/^[A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                errorMessage: t(
                                  "Your name must be composed only with letter and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            label={t("Email") + " *"}
                            id="registration-email"
                            name="registrationemail"
                            type="email"
                            className="form-control"
                            placeholder={t("example@example.com")}
                            onChange={(e) => {
                              if (e.target.value === departmentValues.email) {
                                delete newFields.email;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  email: e.target.value,
                                }));
                              }
                            }}
                            value={departmentValues.email}
                            validate={{
                              email: {
                                value: true,
                                errorMessage: t("Incorrect email"),
                              },
                              maxLength: {
                                value: 100,
                                errorMessage: t("Invalid field"),
                              },
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingDepartmentEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/departments">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetDepartment())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewDepartment);
